import React from 'react'
import connect from '../../../connect'
import Typography from '../../../../../components/common/Typography'
import { intlDateFormat } from '../../../../../utils/dateUtils'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import { InlineContainer } from '../../../../../components/common/Containers'
import ItemMenu from './ItemMenu'

const Item = ({ cat, requestTemplateId }) => {
  return (
    <>
      <TableRow>
        <TableCell align="left">
          <InlineContainer>
            <Typography weight="500" variant="h6">
              {cat.name}
            </Typography>
          </InlineContainer>
        </TableCell>
        <TableCell align="right">
          <ItemMenu cat={cat} requestTemplateId={requestTemplateId} />
        </TableCell>
      </TableRow>
    </>
  )
}

export default connect(Item)
